export default __webpack_public_path__ + "230ab6007d3f3ac5cc2d3c36d4bac234.svg";